<template>
  <transition name="fade" :duration="{ enter: 200, leave: 150 }">
    <div class="confirm" v-if="showConfirmIternal">
      <div class="confirm__overlay"></div>
      <div class="confirm__content">
        <div class="confirm__card">
          <div class="confirm__icon" :class="`confirm__icon--${confirmType}`">
            <i class="mdi mdi-information"></i>
          </div>
          <div class="confirm__text">
            <p class="title">{{ title }}</p>
            <p class="description">{{ description }}</p>
            <div class="confirm__action">
              <Layout>
                <Column align="right">
                  <Button
                    v-for="(action, index) in actions"
                    :key="index"
                    v-bind="action.props"
                    @click="() => onSelectAction(action)"
                  >
                    {{ action.text }}
                  </Button>
                </Column>
              </Layout>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Confirm',
  data() {
    return {
      showConfirmIternal: false,
      title: '',
      description: '',
      confirmType: 'information',
      actions: [],
    };
  },
  mounted() {
    this.$root.$on('openConfirm', (title, description, confirmType, actions) => {
      this.title = title || '';
      this.description = description || '';
      this.confirmType = confirmType || 'information';
      this.actions = actions || [];
      this.showConfirmIternal = true;
    });
  },
  methods: {
    onSelectAction(action) {
      if (action.callback) {
        action.callback.apply(null);
      }
      this.showConfirmIternal = false;
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 667px) {
  .confirm__content {
    width: 90vw !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.38, 0.81, 0.13, 0.94);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.confirm {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  z-index: 10001;
  &__overlay {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: rgba(0, 0, 0, 0.3);
  }
  &__content {
    position: absolute;
    width: 480px;
    background-color: #fff;
    border: 1px solid #bdc6cc;
    padding: 24px 22px;
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    border-radius: 8px;
  }
  &__text {
    .title {
      font-size: 18px;
      font-weight: 700;
      margin-top: 0;
      color: #333333;
    }
    .description {
      color: #333333;
    }
  }
  &__card {
    display: flex;
  }
  &__icon {
    margin-right: 12px;
    font-size: 20px;
    &--information {
      color: #5186ff;
    }
    &--danger {
      color: #f25555;
    }
  }
}
</style>
